import ReduxToolkit, { createSlice } from '@reduxjs/toolkit';

const NAME = 'token';

export type ValueType = string;

const initialState: ValueType = null;

const setAction: ReduxToolkit.CaseReducer<
	ValueType,
	ReduxToolkit.PayloadAction<ValueType>
> = (state, action) => {
	return action.payload;
};

export const tokenSlice = createSlice({
	name: NAME,
	initialState,
	reducers: {
		setToken: setAction,
	},
});
